export default __webpack_public_path__ + "media/images/home/slide_2025_ryukogo_lg-588873d0c5aa495e5484eef1b00c56b6.png";